'use client';

import { c as _c } from "react/compiler-runtime";
import { useDrawStatus } from '@svs/nova-poolbetting/core/nextjs/draw';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import { DrawCardStatusMobile } from '@svs/nova-poolbetting/ui/DrawManager/client';
import type { ReactNode } from 'react';
type DrawCardStatusMobileManagerProps = {
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
  isMyBetsOrResult?: boolean;
};

/**
 * Component for draw card status shown in draw card.
 *
 * @param root0 Component props
 * @param root0.drawNumber Draw number to load draw from
 * @param root0.product Product number to load draw from
 * @param root0.isMyBetsOrResult Whether the draw card is used in my bets or result view, which has different requirements for when to show status
 * @returns component that renders the status for a draw
 */
export default function DrawCardStatusMobileManager(t0) {
  const $ = _c(3);
  const {
    drawNumber,
    product,
    isMyBetsOrResult
  } = t0;
  const status = useDrawStatus(drawNumber, product);
  let t1;
  if ($[0] !== isMyBetsOrResult || $[1] !== status) {
    t1 = <DrawCardStatusMobile status={status} isMyBetsOrResult={isMyBetsOrResult} />;
    $[0] = isMyBetsOrResult;
    $[1] = status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}